import React from "react";

const EmpresasMontadoras = () => {
  return <div>EmpresasMontadoras</div>;
};

export default EmpresasMontadoras;
